/**
 * Generic library Module
 * Contain components common to cases
 */
//Core
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { UIModule } from '../ui/ui.module';
import { DatePipeModule } from './../date/date.module';
import { PipesModule } from '../pipes/pipes.module';
import { PricePipesModule } from 'libraries/pipes/price/price-pipes.module';
import { PricePipeModule } from 'libraries/pipes/price/price-pipe.module';
import { ClickStopModule } from "../directive/clickstop/click-stop.module";
import { StickyModule } from "libraries/directive/sticky/sticky.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        UIModule,
        DatePipeModule,
        PricePipesModule,
        PricePipeModule,
        PipesModule,
        ClickStopModule,
        StickyModule
    ]
})
export class GenericModule {
}
